module.exports = __webpack_public_path__ + "static/media/1.31bfd3b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/1.png
// module id = 1219
// module chunks = 0